import { Gamepad2, Film, Speech, Music, Mic } from 'lucide-react';
import { useT } from '../i18n/I18nModule';

/** API may send camelCase or snake_case. Legacy stream is shown like keskustelu. */
function normalizedEventType(raw) {
  if (raw === 'stream') return 'keskustelu';
  return raw || '';
}

const ICON_SIZE = 18;

function TypeIcon({ eventType, livestreamType }) {
  const t = normalizedEventType(eventType);
  const common = { size: ICON_SIZE, className: 'Event-type-title-icon', 'aria-hidden': true };
  if (t === 'game') return <Gamepad2 {...common} />;
  if (t === 'movie') return <Film {...common} />;
  if (t === 'keskustelu') return <Speech {...common} />;
  if (t === 'livestream') {
    if (livestreamType === 'talk') return <Mic {...common} />;
    return <Music {...common} />;
  }
  return null;
}

/**
 * Renders optional type icon + title for events (game / movie / keskustelu / livestream).
 */
export default function EventTypeTitle({ event, eventType: eventTypeProp, children, fallback = '—', className }) {
  const t = useT();
  const titleText = children != null ? children : (event?.title ?? fallback);
  const et = eventTypeProp ?? event?.eventType ?? event?.event_type ?? '';
  const iconType = normalizedEventType(et);
  const livestreamType = event?.livestreamType ?? event?.livestream_type ?? '';
  const showIcon =
    iconType === 'game' ||
    iconType === 'movie' ||
    iconType === 'keskustelu' ||
    iconType === 'livestream';
  const room = event?.roomNumber ?? event?.room_number;
  const roomSuffix = room != null ? ` @${t('event.room')} ${room}` : '';

  return (
    <span className={['Event-type-title', className].filter(Boolean).join(' ')}>
      {showIcon && (
        <span className="Event-type-title-icon-wrap">
          <TypeIcon eventType={et} livestreamType={livestreamType} />
        </span>
      )}
      {titleText}
      {roomSuffix ? <span className="Event-type-title-room">{roomSuffix}</span> : null}
    </span>
  );
}
